var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPublic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6165BA0F-A647-4D3C-9FC9-9AEB9E6A7B45")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-468.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(15.100000, 13.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Social-/-public",
    transform: "translate(152.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Social-/-public"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 51 0 51 51 0 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,4.25 C13.77,4.25 4.25,13.77 4.25,25.5 C4.25,37.23 13.77,46.75 25.5,46.75 C37.23,46.75 46.75,37.23 46.75,25.5 C46.75,13.77 37.23,4.25 25.5,4.25 Z M8.5,25.5000006 C8.5,24.2037506 8.66999999,22.9287506 8.94624999,21.7175006 L19.1037497,31.8750006 L19.1037497,34.0000006 C19.1037497,36.3375006 21.0162496,38.2500006 23.3537495,38.2500006 L23.3537495,42.3512506 C15.0024998,41.2887506 8.5,34.1487506 8.5,25.5000006 Z M38.0162499,36.9750007 C37.4637499,35.2537498 35.8912499,34.0000006 33.9787495,34.0000006 L31.8537498,34.0000006 L31.8537498,27.6250004 C31.8537498,26.4562504 30.8974998,25.5000003 29.7287498,25.5000003 L16.9787495,25.5000003 L16.9787495,21.2500002 L21.2287496,21.2500002 C22.3974996,21.2500002 23.3537496,20.2937502 23.3537496,19.1250001 L23.3537496,14.875 L27.6037497,14.875 C29.9412498,14.875 31.8537498,12.9624999 31.8537498,10.6249998 L31.8537498,9.75374982 C38.0799999,12.2612499 42.5,18.3812501 42.5,25.5000003 C42.5,29.9200005 40.77875,33.9575006 38.0162499,36.9750007 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPublic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/public.41d1d74a.svg";
export { ForwardRef as ReactComponent };